module.exports = __webpack_public_path__ + "static/media/lesson-backto14.aebb6987.png";